/**
 * Validates if student creation exceeds the dynamic plan limit from payments data.
 * @param {number} currentStudentCount - Total existing students count
 * @param {Array|Object} paymentsOrUser - payments array or user object with payments
 * @returns {{ isExceeded: boolean, limit: number|null, modelId: number|null }}
 */
export const checkStudentCreationLimit = (currentStudentCount, paymentsOrUser) => {
  let modelDetails = null;
  let modelId = null;

  const inspect = (item) => {
    if (!item || typeof item !== "object") return;
    if (!modelId && item.model_id) {
      modelId = Number(item.model_id);
    }
    if (!modelDetails) {
      if (item.model_details) {
        modelDetails = item.model_details;
      } else if (item.additional_data) {
        modelDetails = item.additional_data;
      } else if (item.students !== undefined) {
        modelDetails = item;
      }
    }
  };

  // 1. Direct object or array checks
  if (Array.isArray(paymentsOrUser)) {
    const coaching = paymentsOrUser.find(
      (p) =>
        (p?.plan_type === "coaching" && (p?.model_details || p?.additional_data)) ||
        p?.model_details ||
        p?.students !== undefined
    );
    if (coaching) inspect(coaching);
    else paymentsOrUser.forEach(inspect);
  } else if (paymentsOrUser && typeof paymentsOrUser === "object") {
    if (Array.isArray(paymentsOrUser.payments)) {
      const coaching = paymentsOrUser.payments.find(
        (p) =>
          (p?.plan_type === "coaching" && (p?.model_details || p?.additional_data)) ||
          p?.model_details ||
          p?.students !== undefined
      );
      if (coaching) inspect(coaching);
      else paymentsOrUser.payments.forEach(inspect);
    }
    inspect(paymentsOrUser);
  }

  // 2. Fallback to localStorage userData if not found
  if (!modelDetails) {
    try {
      const stored = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      if (Array.isArray(stored.payments)) {
        const coaching = stored.payments.find(
          (p) =>
            (p?.plan_type === "coaching" && (p?.model_details || p?.additional_data)) ||
            p?.model_details ||
            p?.students !== undefined
        );
        if (coaching) inspect(coaching);
        else stored.payments.forEach(inspect);
      }
      inspect(stored);
    } catch (e) {
      console.error("Error reading stored userData in studentLimitUtils:", e);
    }
  }

  // 3. Normalize stringified JSON
  if (typeof modelDetails === "string") {
    try {
      modelDetails = JSON.parse(modelDetails);
    } catch (e) {
      console.error("Error parsing modelDetails JSON:", e);
    }
  }

  // 4. Handle array of modelDetails
  if (Array.isArray(modelDetails) && modelDetails.length > 0) {
    modelDetails = modelDetails[0];
  }

  const rawLimit = modelDetails?.students;
  const limit =
    rawLimit !== undefined && rawLimit !== null && !isNaN(Number(rawLimit))
      ? Number(rawLimit)
      : null;

  console.log(
    "[studentLimit] Current Count:",
    currentStudentCount,
    "| Model ID:",
    modelId,
    "| Dynamic Limit:",
    limit,
    "| modelDetails:",
    modelDetails
  );

  if (limit !== null && currentStudentCount >= limit) {
    return { isExceeded: true, limit, modelId, modelDetails };
  }

  return { isExceeded: false, limit: limit || Infinity, modelId, modelDetails };
};

export default checkStudentCreationLimit;
